import { AIAccounting } from "@graylog/enterprise-api";
const toUsageRequestArg = ({
  timerange,
  group_by: groupBy,
  interval,
  timezone,
  feature_id: featureId,
  feature_group: featureGroup,
  provider,
  model,
  status
}) => ({
  timerange,
  group_by: groupBy,
  timezone,
  feature_id: featureId,
  feature_group: featureGroup,
  provider,
  model,
  status,
  interval
});
export const fetchUsage = (request) => AIAccounting.usage(toUsageRequestArg(request));
